"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const SupportingCreativeFormatAspectRatio_1 = require("./SupportingCreativeFormatAspectRatio");
const SupportingCreativeFormatFastStart_1 = require("./SupportingCreativeFormatFastStart");
const SupportingCreativeFormatPlaybackTime_1 = require("./SupportingCreativeFormatPlaybackTime");
class SupportingCreativeFormatAttribute {
    constructor({ aspectRatio, playbackTime, fastStart, }) {
        this.toJSON = () => ({
            aspectRatio: this.aspectRatio && this.aspectRatio.toJSON(),
            playbackTime: this.playbackTime && this.playbackTime.toJSON(),
            fastStart: this.fastStart && this.fastStart.toJSON(),
        });
        this.aspectRatio = aspectRatio;
        this.playbackTime = playbackTime;
        this.fastStart = fastStart;
    }
}
SupportingCreativeFormatAttribute.fromJSON = (json) => {
    const { aspectRatio, playbackTime, fastStart } = Object.assign({}, json);
    const _aspectRatio = aspectRatio ? SupportingCreativeFormatAspectRatio_1.default.fromJSON(aspectRatio) : undefined;
    const _playbackTime = playbackTime ? SupportingCreativeFormatPlaybackTime_1.default.fromJSON(playbackTime) : undefined;
    const _fastStart = fastStart ? SupportingCreativeFormatFastStart_1.default.fromJSON(fastStart) : undefined;
    return new SupportingCreativeFormatAttribute({
        aspectRatio: _aspectRatio,
        playbackTime: _playbackTime,
        fastStart: _fastStart,
    });
};
exports.default = SupportingCreativeFormatAttribute;
